<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="15" fill="#FFECC8" />
    <path d="M15.0985 5.8821L13.4742 7.50637L19.9022 13.9458L5.88281 13.9458L5.88281 16.2498L19.9022 16.2498L13.4627 22.6777L15.0985 24.3135L24.3142 15.0978L15.0985 5.8821Z" fill="#F49136" />
  </svg>
</template>
